module.exports = __webpack_public_path__ + "img/blockchain.1b42fef0.jpg";